// Chat layers come in two flavours; the direction isn't a setting the user edits, it's the layer's widget type.
export const CHAT_WIDGET_TYPES = {
	'chat-vertical': { horizontal: false },
	'chat-horizontal': { horizontal: true },
};

export const isChatWidgetType = widgetType => widgetType in CHAT_WIDGET_TYPES;

// scrollSpeed is the fraction of the distance left that the chat covers each frame, so the settings slider spreads it
// logarithmically (same mapping as the chat widget's own settings page).
const MIN_SCROLL_SPEED = 0.01;
const MAX_SCROLL_SPEED = 0.5;
export const DEFAULT_SCROLL_SPEED = 0.2;
const SCROLL_SPEED_RATIO = MAX_SCROLL_SPEED / MIN_SCROLL_SPEED;

export function calcScrollSpeed(position) {
	const speed = MIN_SCROLL_SPEED * Math.pow(SCROLL_SPEED_RATIO, Math.min(100, Math.max(0, position)) / 100);
	return Math.round(speed * 10000) / 10000;
}

export function calcSliderPosition(speed) {
	const clamped = Math.min(MAX_SCROLL_SPEED, Math.max(MIN_SCROLL_SPEED, speed || DEFAULT_SCROLL_SPEED));
	return Math.round(100 * Math.log(clamped / MIN_SCROLL_SPEED) / Math.log(SCROLL_SPEED_RATIO));
}

export const getDefaultChatSettings = () => ({
	alignment: 'top',
	scrollSpeed: DEFAULT_SCROLL_SPEED,
	enableTTS: false,
	enableEventSounds: false,
	volume: 100,
	inTransition: null,
	outTransition: null,
	duration: 500,
	linger: 8000,
	loadTimeout: 5000,
	fontFamily: '',
	fontSize: 0,
	letterSpacing: 0,
	textAlign: 'left',
	boldText: false,
	italicText: false,
	underlineText: false,
	strikethroughText: false,
	uppercaseText: false,
	textColor: 'rgba(255, 255, 255, 1)',
	textBg: 'rgba(0, 128, 0, 1)',
	giftColor: 'rgba(0, 0, 0, 1)',
	giftBg: 'rgba(255, 195, 0, 1)',
	blurRadius: 0,
	spreadRadius: 0,
	shadowColor: 'rgba(0, 0, 0, 1)',
});

// The account's own chat widget settings, cut down to the fields a chat layer has, to seed a new layer.
export function createChatLayerSettings(accountSettings) {
	const defaults = getDefaultChatSettings();
	const seeded = {};
	for(const key of Object.keys(defaults)) if(accountSettings?.[key] != null) seeded[key] = accountSettings[key];
	return { ...defaults, ...seeded };
}

// What ChatWidget.applySettings() gets for a layer: the layer's settings, plus the direction its widget type implies.
export function createChatWidgetSettings(widgetType, layerSettings) {
	return { ...getDefaultChatSettings(), ...layerSettings, horizontal: CHAT_WIDGET_TYPES[widgetType]?.horizontal ?? false };
}
